import React from 'react'
import LinkBudgetCalculator from '../../components/link-budget-calculator'

const LinkBudgetCalculatorPage = () => {
  return <LinkBudgetCalculator />
}

export default LinkBudgetCalculatorPage
